ANTRAGSGRUEN_STRINGS = {
    "std": {
        "add_tag": "Anlegen",
        "del_confirm": "Wirklich löschen?",
        "draft_del": "Entwurf löschen",
        "draft_del_confirm": "Entwurf wirklich löschen?",
        "draft_date": "Entwurf vom",
        "draft_restore_confirm": "Diesen Entwurf wiederherstellen?",
        "min_x_supporter": "Es müssen mindestens %NUM% Unterstützer*innen angegeben werden.",
        "missing_resolution_date": "Es muss ein Beschlussdatum angegeben werden.",
        "missing_gender": "Bitte gib etwas im Gender-Feld an.",
        "pw_x_chars": "Das Passwort muss mindestens %NUM% Zeichen lang sein.",
        "pw_min_x_chars": "Min. %NUM% Zeichen",
        "pw_no_match": "Die beiden Passwörter stimmen nicht überein.",
        "leave_changed_page": "Es gibt noch ungespeicherte Änderungen. Diese Seite wirklich verlassen?",
        "moved_paragraph_from": "Verschoben von Absatz ##PARA##",
        "moved_paragraph_to": "Verschoben zu Absatz ##PARA##",
        "moved_paragraph_from_line": "Verschoben von Absatz ##PARA## (Zeile ##LINE##)",
        "moved_paragraph_to_line": "Verschoben zu Absatz ##PARA## (Zeile ##LINE##)"
    },
    "merge": {
        "initiated_by": "Gestellt von",
        "title_open_in_blank": "Den Änderungsantrag in einem neuen Fenster öffnen",
        "title_del_title": "Die Überschrift \"Kollidierender Änderungsantrag: ...\" entfernen",
        "title_del_colliding": "Den kompletten kollidierenden Block entfernen",
        "title": "Überschrift",
        "change_accept": "Übernehmen",
        "change_reject": "Verwerfen",
        "colliding_title": "Kollidierender ÄA",
        "colliding_start": "Ab hier Kollisionen",
        "colliding_end": "Bis hier Kollisionen",
        "reloadParagraph": "Wenn diese Auswahl geändert wird, gehen händische Änderungen in diesem Paragraph verloren. Weiter?",
        "mergedCollisionHint": "Diese Änderung kollidiert mit einer Vorigen. Achte beim Einpflegen besonders auf die schlussendliche Formulierung!",
        "modU": "Modifizierte Übernahme"
    },
    "admin": {
        "adminMayEditConfirm": "Wenn dies deaktiviert wird, wirkt sich das auch auf alle bisherigen Anträge aus und kann für bisherige Anträge nicht rückgängig gemacht werden. Wirklich setzen?",
        "deleteDataConfirm": "Diese Angabe wirklich löschen?",
        "agendaAddEntry": "Eintrag hinzufügen",
        "agendaAddDate": "Datum hinzufügen",
        "agendaShowTimes": "Genaue Zeiten festlegen",
        "agendaDelEntryConfirm": "Diesen Tagesordnungspunkt mitsamit Unterpunkten löschen?",
        "removeAdminConfirm": "Diesem Zugang wirklich die Admin-Rechte entziehen?",
        "removeUserConfirm": "%NAME% wirklich von DIESER Veranstaltung entfernen? Eingereichte Anträge etc. bleiben erhalten und müssen explizit gelöscht werden.",
        "deleteUserConfirm": "%NAME% wirklich löschen? Eingereichte Anträge etc. bleiben erhalten und müssen explizit gelöscht werden.",
        "emailMissingCode": "Im E-Mail-Text muss der Code %ACCOUNT% vorkommen.",
        "emailMissingLink": "Im E-Mail-Text muss der Code %LINK% vorkommen.",
        "emailMissingTo": "Es wurden keine E-Mail-Adressen angegeben.",
        "emailMissingUsername": "Es wurden keine Namen angegeben.",
        "emailNumberMismatch": "Es wurden nicht genauso viele Namen wie E-Mail-Adressen angegeben. Bitte achte darauf, dass für jede Zeile bei den E-Mail-Adressen exakt ein Name angegeben wird!",
        "delMotionConfirm": "Diesen Antrag wirklich löschen?",
        "delAmendmentConfirm": "Diesen Änderungsantrag wirklich löschen?",
        "delPageConfirm": "Diese Seite wirklich löschen?",
        "deleteMotionSectionConfirm": "Wenn dieser Abschnitt gelöscht wird, wird er auch unwiderruflich in allen Anträgen dieses Types gelöscht. Wirklich löschen?",
        "consDeleteConfirm": "Soll diese Veranstaltung mitsamt aller Anträge und Änderungsanträge wirklich gelöscht werden?",
        "gotoUpdateModeConfirm": "Soll der Update-Modus aktiviert werden? Während der Update-Modus aktiv ist, ist diese Antragsgrün-Version nicht verfügbar."
    }
};
